module.exports = new __parcel__URL__("RestrictedError.e0fef1fb.svg").toString();